import { Component, Input, ViewChild, OnInit, AfterViewInit, EventEmitter, Output } from '@angular/core';
// import { AlDialogComponent } from '../al-dialog/al-dialog.component';
import { AppUtility } from '../../utils/utility';
import { DomStorageFallbackService } from '../../services/DomStorageFallback.service';
import { GenericService } from '../../services/generic.service';

import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
    selector: 'al-edits',
    templateUrl: './al-edits.component.html'
})

export class AlEditsComponent implements OnInit, AfterViewInit {
    @Input() returnBtnData: string = 'Cancle';
    @Input() continueBtnData: string = 'Ok';
    @Input() actionBtnData: string = 'Show Edits';
    @Input() editMessagesData: any;
    @Input() _visible: boolean = false;
    @Input() redirectionPath: string;
    @Input() isAF: boolean;
    editMessagesArray = [];
    editTitleArray = [];
    @Input() editTitleData: string;
    editSeverity: string; // ERROR/CRITICAL, OVERRIDEABLE, WARNING, INFORMATIONAL, NONE, CROSSPLAN
    editsTextKeys: any = [
        {
            'link': {
                'CROSS_PLAN_EDIT_PAGE_URL_LINK': {
                    'displayText': 'INVALID LINK [lineage=19920_1.0, linkName=CROSS_PLAN_EDIT_PAGE_URL_LINK ]<br/>Possible Reasons:<br/> a)Invalid link name <br/> b)Link cannot be found for a given lineage.',
                    'additionalTags': null,
                    'attributes': {},
                    'tag': '<A>INVALID LINK [lineage=19920_1.0, linkName=CROSS_PLAN_EDIT_PAGE_URL_LINK ]<br/>Possible Reasons:<br/> a)Invalid link name <br/> b)Link cannot be found for a given lineage.</A>'
                }
            },
            'text': {
                'defaultWebServiceEditTextKey': 'An unexpected error has occurred while processing your request.',
                'validation_warningLightboxTitle': 'Warning',
                'validation.overrideLightboxTitle': 'Attention',
                'validation.informationLightboxTitle': 'Information',
                'editMessageNumberTxt': ''
            }
        }
    ];

    @ViewChild('editDialog', { static: false }) editDialog;

    @Output() continueEdit = new EventEmitter();


    // tslint:disable-next-line: max-line-length
    constructor(private router: Router, private genericService: GenericService, private domStorageFB: DomStorageFallbackService, private appUtility: AppUtility) {
    }

    ngOnInit() {

        this.validateData(this.editMessagesData);
    }

    ngAfterViewInit() { }
    /* istanbul ignore next */
    validateData(data) {
        const editSeverityArray = ['Crossplan', 'Critical', 'Error', 'Warning', 'Overrideable', 'Informational'];
        const editsObj = {};
        if (data) {
            if (this.appUtility.isPostAuth()) {
                if (this.domStorageFB.getItem('editsValue', '')) {
                    this.editsTextKeys = this.appUtility.transformKeys(JSON.parse(this.domStorageFB.getItem('editsValue', '')).text);
                } else {
                    this.editsTextKeys = this.editsTextKeys[0].text;
                }
            }
            const hasEditMessageGroupResponse = data.hasOwnProperty('editMessageGroupResponse');
            if (hasEditMessageGroupResponse) {
                const hasEditMessages = data.editMessageGroupResponse.hasOwnProperty('editMessages');
                if (hasEditMessages && data.editMessageGroupResponse.editMessages.length > 0) {

                    editSeverityArray.map(severity => {
                        editsObj[severity] = [];

                        data.editMessageGroupResponse.editMessages.map(message => {
                            if (message.editMessage && message.editMessage.indexOf(message.editId) < 0) {
                                message.editMessage = message.editMessage + ' (' + message.editId + ')';
                            }

                            if (message.hasOwnProperty('editSeverity')) {
                                if (severity === message.editSeverity) {
                                    if (message.editMessage.trim().length > 0) {
                                        editsObj[severity].push(message.editMessage);
                                    } else {
                                        let errorMessage = this.editsTextKeys.defaultWebServiceEditTextKey;
                                        if (errorMessage && errorMessage.indexOf('${token:editId}')) {
                                            errorMessage = errorMessage.replace('${token:editId}', message.editId);
                                        }
                                        editsObj[severity].push(errorMessage);
                                    }
                                }
                            }
                        });

                    });

                    this.editMessagesArray = [];
                    this.editTitleArray = [];
                    for (let key in editsObj) {
                        if (editsObj.hasOwnProperty(key) && editsObj[key].length > 0) {
                            this.editSeverity = key.toLowerCase();
                            if (this.editSeverity === 'crossplan') {
                                this.redirectTo(this.redirectionPath);
                                return true;
                            }
                            editsObj[key].map((index) => {
                                this.editTitleArray.push(key.toLowerCase());
                                this.editMessagesArray.push(index);
                            });
                            if (this.editSeverity === 'critical') {
                                return true;
                            }
                        }
                    }
                    if (this.editSeverity !== 'critical' && this.editSeverity !== 'error') {
                        this.setEditsDialogTitle(this.editTitleArray);
                        setTimeout(() => {
                            this.showEdits();
                        }, 100);
                        return true;
                    }
                }
            }

        }
    }
    /* istanbul ignore next */
    hideEditDialog(event) {
        this.continueEdit.emit(event);
        this.redirectTo(this.redirectionPath);
        if (this.editSeverity) {
            this.editDialog.hideDialog(event);
            return true;
        }
    }
    /* istanbul ignore next */
    showEditInline(event) {
        if (this.editSeverity) {
            this.editSeverity = 'critical';
            this.editDialog.hideDialog(event);
        }
    }
    /* istanbul ignore next */
    showEdits() {
        if (this.editDialog) {
            this.editDialog.showDialog();
        }
    }
    /* istanbul ignore next */
    redirectTo(path) {
        let orgName = '';
        if (this.domStorageFB.getItem('lr_json_data') && JSON.parse(this.domStorageFB.getItem('lr_json_data')).orgName) {
            orgName = JSON.parse(this.domStorageFB.getItem('lr_json_data')).orgName;
        }
        // for AF
        if (path && this.isAF) {
            if (window.location.href.indexOf(this.genericService.getAngularFirstUrl())) {
                this.router.navigate(['/', path]);
            } else {
                window.location.href = this.genericService.getAngularFirstUrl() + '#/web/' + orgName + path;
            }

        } else if (path) {
            window.location.href = this.genericService.getUpointNextUrl() + '/web/' + orgName + path;
        }
    }
    /* istanbul ignore next */
    setEditsDialogTitle(editSeverity) {

        for (let i of editSeverity) {
            if (i === 'warning') {
                this.editSeverity = i;
                this.editTitleData = this.editsTextKeys.validation_warningLightboxTitle;
                return true;
            } else if (i === 'overrideable') {
                this.editSeverity = i;
                this.editTitleData = this.editsTextKeys.validation_overrideLightboxTitle;
                return true;
            } else if (i === 'informational') {
                this.editSeverity = i;
                this.editTitleData = this.editsTextKeys.validation_informationLightboxTitle;
                return true;
            }
        }
    }
}
